import * as React from "react";
import moment from "moment";
import {
    getFormattedAddress,
    isNullOrWhitespace,
} from "../../services/stringService";

export const RetrocheckFacesheetCoverage = ({patientCoverages}) => {
    return (
        
        <div className="facesheet-personal">
            {patientCoverages?.coverages &&
            patientCoverages?.coverages?.map(x => (
                <li className="facesheet-history__item" key={x.templateKey}>
                    <div className="facesheet-personal__info">
                        <div className="facesheet-personal__left">
                            <div className="facesheet-personal__info-item">
                                <span className="p-regular">
                                    <span className="h5">Company-Insurance Name </span>
                                    <span className="p-regular">{x.companyName}</span>
                                </span>
                            </div>
                        
                            <div className="facesheet-personal__info-item">
                                <span className="h5">Plan Description </span>
                                <span className="p-regular">
                                    {x.plan}
                                </span>
                            </div>
                            <div className="facesheet-personal__info-item">
                                <span className="p-regular">
                                    <span className="h5">Member ID </span>
                                    {x.memberId}
                                </span>
                            </div>
                            <div className="facesheet-personal__info-item">
                                <span className="p-regular">
                                    <span className="h5">Co-Pay </span>
                                    {getFormattedAddress(x.address)}
                                </span>
                            </div>
                        </div>
                        {/* Need to get deductable and copay*/}
                        <div className="facesheet-personal__right">
                            <div className="facesheet-personal__info-item">
                                <span className="h5">Group Number </span>
                                <span className="p-regular">{x.groupNumber}</span>
                            </div>
                            <div className="facesheet-personal__info-item">
                                <span className="h5">Deductible </span>
                                <span className="p-regular">{x.groupNumber}</span>
                            </div>
                        </div>
                    </div>
                </li>
            ))}
            
        </div>
    );
};
